import type { ComparisonCandidate, SavedSenseDescriptor } from "../../contracts/ai/schemas.ts";
import type { VocabularySnapshot } from "../../domain/vocabulary/types.ts";
import { meaningsForWord } from "../../domain/vocabulary/grouping.ts";

export function savedSenseDescriptors(
  snapshot: VocabularySnapshot | null,
  wordId?: string,
): SavedSenseDescriptor[] {
  if (!snapshot || !wordId) {
    return [];
  }
  return meaningsForWord(snapshot, wordId).map((meaning) => ({
    meaningId: meaning.id,
    type: meaning.type,
    shortLabel: meaning.shortLabel,
    definition: meaning.definition,
    example: meaning.example,
  }));
}

export function comparisonIndexFromSnapshot(
  snapshot: VocabularySnapshot | null,
): ComparisonCandidate[] {
  if (!snapshot) {
    return [];
  }
  return snapshot.meanings.map((meaning) => {
    const word = snapshot.words.find((item) => item.id === meaning.wordId);
    return {
      meaningId: meaning.id,
      word: word?.displayText ?? "",
      type: meaning.type,
      shortLabel: meaning.shortLabel,
      definition: meaning.definition,
      example: meaning.example,
      contentRevision: meaning.contentRevision,
    };
  });
}
